import { View } from "@/components/ui";
import { AccountInfoCard } from "@/components/shared/account-info-card";
import { AddressMoreActions } from "./address-more-actions";
import { useClientAddressesQuery } from "@/gqlhooks/profile/useClientAddressesQuery";
import { Typography } from "@/components/shared/typography";
import { useRoute } from "@/components/shared/router";
import { Skeleton } from "@/components/ui/skeleton";
import { joinAddressParts } from "@/containers/profile/utils";

const AddressSkeleton = () => {
  return (
    <View className="flex flex-col gap-4 px-4 py-4 pb-12 md:px-0 md:pt-0">
      {Array.from({ length: 3 }).map((_, index) => (
        <View
          key={index}
          className="rounded-lg border border-border bg-card p-4"
        >
          <View className="flex flex-col gap-2">
            <View className="flex flex-row items-center gap-2">
              <Skeleton className="h-5 w-16" />
              <Skeleton className="h-5 w-12 rounded-full" />
            </View>
            <View className="flex flex-row gap-2">
              <Skeleton className="h-4 flex-1" />
              <Skeleton className="h-4 w-20" />
            </View>
          </View>
          <View className="flex flex-row gap-2 py-2">
            <Skeleton className="h-8 flex-1 rounded-full" />
            <Skeleton className="h-8 w-8 rounded-full" />
          </View>
        </View>
      ))}
    </View>
  );
};

const AddressActions = ({ primary, id }: { primary: boolean; id: string }) => {
  const { push } = useRoute();

  const handleClick = () => {
    push({
      pageKey: "address",
      params: {
        id,
      },
    });
  };
  return (
    <View className="flex w-full flex-1 flex-row items-center gap-2">
      <View
        className="flex w-full flex-1 cursor-pointer flex-row items-center justify-center gap-1 rounded-full border border-primary-border p-2"
        onClick={handleClick}
      >
        <Typography variant="body-sm" color="brand-primary">
          Edit
        </Typography>
      </View>

      {!primary && <AddressMoreActions addressId={id} />}
    </View>
  );
};

export const AddressListContainer = () => {
  const { data: addresses, loading } = useClientAddressesQuery();

  if (!addresses) return null;

  if (loading) {
    return <AddressSkeleton />;
  }

  return (
    <View className="flex flex-col gap-4 px-4 py-4 pb-12 md:px-0 md:pt-0">
      {addresses.map((item) => {
        const hasLabel = Boolean(item.label?.toString().trim());
        const headerText = hasLabel ? item.label : (item.postalCode ?? "");
        const line2Text = hasLabel
          ? joinAddressParts(item.postalCode, item.fullAddress, item.unitNumber)
          : joinAddressParts(item.fullAddress, item.unitNumber);

        return (
          <AccountInfoCard
            key={item.id}
            primary={item.primary}
            header={headerText || ""}
            bodyText={line2Text}
            subBodyText=""
            actions={<AddressActions primary={item.primary} id={item.id} />}
            direction={"row"}
          />
        );
      })}
    </View>
  );
};
